import React, {useState} from 'react';
import withCaretakers from "../../../hoc/withCaretakers";
import css from "./AddItem.module.css";
import {BottomBar, Tour} from "../../../components";
import {TitleWrapper} from "../../../contexts/TitleProvider";
import i18n from "../../../i18n";
import {getPageHelpSteps} from "../../../help/tools";

const AddItemButton = props => {
    return (
        <div className={css.button + " " + props.className} onClick={props.onClick}>{props.text}</div>
    );
}

const AddItemDate = props => {
    const [helpOpen, setHelpOpen] = useState(false);
    const doHelp                  = () => setHelpOpen(true);
    const closeHelp               = () => setHelpOpen(false);

    const urlSuffix = props.caretakerUuid + '/edit/new/' + props.match.params.date +
        (props.match.params.hour ? '/' + props.match.params.hour : '');

    return (
        <TitleWrapper title={props.caretaker ? i18n.calendarAddItemFor.replace("%1", props.caretaker.name) : i18n.caretakersItemAdd}>
            <Tour
                isOpen={helpOpen}
                onRequestClose={closeHelp}
                steps={getPageHelpSteps("caretakerAddItem")}
            />
            <div>
                <div className="content-list">
                    <AddItemButton
                        className={css.tourAppointment}
                        text={i18n.calendarTypeSingular.appointment}
                        onClick={() => props.history.push('/caretakers/calendar/appointments/' + urlSuffix)}
                    />
                    <AddItemButton
                        className={css.tourReminder}
                        text={i18n.calendarTypeSingular.reminder}
                        onClick={() => props.history.push('/caretakers/calendar/reminders/' + urlSuffix)}
                    />
                    <AddItemButton
                        className={css.tourTvProgram}
                        text={i18n.calendarTypeSingular.tvshow}
                        onClick={() => props.history.push('/caretakers/calendar/tvshows/' + urlSuffix)}
                    />
                    <AddItemButton
                        className={css.tourBirthday}
                        text={i18n.calendarTypeSingular.birthday}
                        onClick={() => props.history.push('/caretakers/calendar/birthdays/' + urlSuffix)}
                    />
                    <BottomBar backButton onHelp={doHelp} onCloseHelp={closeHelp} helpOpen={helpOpen}/>
                </div>
            </div>
        </TitleWrapper>
    );
}


export default withCaretakers(AddItemDate);